module.exports = __webpack_public_path__ + "static/media/0.15c3cfd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/0.png
// module id = 690
// module chunks = 0